import { Link } from "react-router-dom";
import { Phone, Mail, Clock, Instagram, ArrowUp, MapPin } from "lucide-react";

const services = [
  { name: "Interior Painting", path: "/services/interior-painting" },
  { name: "Exterior Painting", path: "/services/exterior-painting" },
  { name: "Cabinet Painting & Refinishing", path: "/services/cabinet-painting" },
  { name: "Deck & Fence Staining", path: "/services/deck-fence-staining" },
  { name: "Drywall Repair & Prep", path: "/services/drywall-repair" },
  { name: "Color Consultation", path: "/services/color-consultation" },
];

const serviceAreas = [
  "Vancouver", "North Vancouver", "West Vancouver", "Burnaby", "Richmond", 
  "New Westminster", "Coquitlam", "Port Coquitlam", "Port Moody", "Surrey", 
  "White Rock", "Delta", "Tsawwassen", "Langley", "Fort Langley", 
  "Maple Ridge", "Pitt Meadows", "Abbotsford"
];

export const Footer = () => {
  const scrollTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <footer className="bg-[#1a2a44] relative" data-testid="footer">
      <button onClick={scrollTop} className="absolute -top-7 left-1/2 -translate-x-1/2 w-14 h-14 bg-[#f97316] hover:bg-[#ea580c] rounded-full flex items-center justify-center shadow-lg hover:-translate-y-1 transition-all" data-testid="scroll-top-btn">
        <ArrowUp className="w-6 h-6 text-white" />
      </button>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-24 pb-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          <div>
            <Link to="/" className="flex items-center mb-6">
              <img 
                src="/logo.svg" 
                alt="VanguardPM"
                className="h-10 w-auto"
              />
            </Link>
            <p className="text-gray-400 mb-6 leading-relaxed">Professional painting services with meticulous attention to detail. Transforming homes across the Lower Mainland.</p>
            <div className="flex gap-3">
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-11 h-11 rounded-full bg-white/10 hover:bg-[#f97316] flex items-center justify-center transition-all group">
                <Instagram className="w-5 h-5 text-gray-400 group-hover:text-white" />
              </a>
              <a href="mailto:info@vanguardpm.com" className="w-11 h-11 rounded-full bg-white/10 hover:bg-[#f97316] flex items-center justify-center transition-all group">
                <Mail className="w-5 h-5 text-gray-400 group-hover:text-white" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-white font-bold text-lg mb-6">Services</h4>
            <ul className="space-y-3">
              {services.map((s) => <li key={s.name}><Link to={s.path} className="text-gray-400 hover:text-[#f97316] transition-colors">{s.name}</Link></li>)}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold text-lg mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li><Link to="/" className="text-gray-400 hover:text-[#f97316] transition-colors">Home</Link></li>
              <li><Link to="/portfolio" className="text-gray-400 hover:text-[#f97316] transition-colors">Portfolio</Link></li>
              <li><Link to="/about" className="text-gray-400 hover:text-[#f97316] transition-colors">About</Link></li>
              <li><Link to="/contact" className="text-gray-400 hover:text-[#f97316] transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold text-lg mb-6">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex gap-3"><Phone className="w-5 h-5 text-[#f97316] flex-shrink-0" /><a href="tel:2368681195" className="text-gray-400 hover:text-[#f97316]">(236)868-1195</a></li>
              <li className="flex gap-3"><Mail className="w-5 h-5 text-[#f97316] flex-shrink-0" /><a href="mailto:info@vanguardpm.com" className="text-gray-400 hover:text-[#f97316]">info@vanguardpm.com</a></li>
              <li className="flex gap-3"><Clock className="w-5 h-5 text-[#f97316] flex-shrink-0" /><span className="text-gray-400">Mon-Fri: 9am-5pm</span></li>
            </ul>
          </div>
        </div>

        {/* Areas We Service */}
        <div className="border-t border-white/10 pt-10 mb-10" data-testid="footer-service-areas">
          <div className="flex items-center gap-2 mb-6">
            <MapPin className="w-5 h-5 text-[#f97316]" />
            <h4 className="text-white font-bold text-lg">Areas We Service</h4>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-x-6 gap-y-3">
            {serviceAreas.map((city) => (
              <div key={city} className="flex items-center gap-2 group">
                <div className="w-1.5 h-1.5 bg-[#f97316] rounded-full flex-shrink-0"></div>
                <span className="text-gray-400 text-sm group-hover:text-[#f97316] transition-colors">{city}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">&copy; {new Date().getFullYear()} Vanguard Painting Masters. All rights reserved.</p>
          <a 
            href="https://www.averoan.com" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="text-gray-500 hover:text-[#f97316] text-sm transition-colors"
          >
            Powered by Averoan Technologies Inc.
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
